/* Jendco Compare Tool
 * Ported from TA Appliances. Data source changed from tbsfy_Specs Values array
 * to hit.meta.custom.algolia_data flat key/value object stored in localStorage.
 */

/* ─── Label map ─────────────────────────────────────────────────────────────
 * key → { label, order, group }
 * group is dormant at launch (flat table). Switch on grouping later by
 * enabling buildGroupedSpecTable() instead of buildFlatSpecTable().
 */
const COMPARE_LABEL_MAP = {
  brand:              { label: 'Brand',                  order: 1,  group: 'General' },
  model:              { label: 'Model',                  order: 2,  group: 'General' },
  type:               { label: 'Product Type',           order: 3,  group: 'General' },
  uom:                { label: 'Unit of Measure',        order: 4,  group: 'General' },
  cal_rating:         { label: 'Arc Rating (cal/cm²)',   order: 10, group: 'Safety & Compliance' },
  ratings:            { label: 'Certifications / Ratings', order: 11, group: 'Safety & Compliance' },
  thickness:          { label: 'Thickness',              order: 20, group: 'Physical' },
  length:             { label: 'Length',                 order: 21, group: 'Physical' },
  capacity:           { label: 'Capacity',               order: 22, group: 'Physical' },
  color:              { label: 'Color',                  order: 23, group: 'Physical' },
  size:               { label: 'Size',                   order: 24, group: 'Physical' },
  'front_d_ring(s)':  { label: 'Front D-Rings',          order: 30, group: 'Protection' },
  'side_d_ring(s)':   { label: 'Side D-Rings',           order: 31, group: 'Protection' },
  hardware:           { label: 'Hardware',               order: 32, group: 'Protection' },
  cfm_delivered:      { label: 'CFM Delivered',          order: 40, group: 'Performance' },
  max_airflow:        { label: 'Max Airflow',            order: 41, group: 'Performance' },
  power_source:       { label: 'Power Source',           order: 42, group: 'Performance' },
};

/* Keys rendered in the column header — not spec rows (C4.9) */
const COMPARE_HEADER_ONLY_KEYS = new Set(['availability', 'badge', 'sku', 'mpn', 'upc']);

/* ─── Utilities ─────────────────────────────────────────────────────────── */

/* SECURITY: product/Algolia data is rendered via string-built innerHTML below.
 * Every value that can originate from product/variant data, Algolia hits, or
 * localStorage must be escaped before concatenation — none of it is safe to
 * treat as trusted markup. Safe for both text nodes and quoted attributes. */
function escapeHtml(value) {
  if (value == null) return '';
  return String(value).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}

function prettifyKey(key) {
  return key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
}

function buildTooltipHtml(key) {
  if (!window.accentuateattr || !Array.isArray(window.accentuateattr)) return '';
  var idx = window.accentuateattr.findIndex(function(a) {
    return (a || '').trim().toLowerCase() === key.trim().toLowerCase();
  });
  if (idx === -1) return '';
  var content = window.accentuateToolContent && window.accentuateToolContent[idx];
  if (!content) return '';
  return '<div class="additional-tooltip">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none" class="icon icon-tooltip">' +
    '<path d="M5.5 11C6.95869 11 8.35764 10.4205 9.38909 9.38909C10.4205 8.35764 11 6.95869 11 5.5C11 4.04131 10.4205 2.64236 9.38909 1.61091C8.35764 0.579463 6.95869 0 5.5 0C4.04131 0 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 0 4.04131 0 5.5C0 6.95869 0.579463 8.35764 1.61091 9.38909C2.64236 10.4205 4.04131 11 5.5 11ZM6.13938 4.52925L5.45187 7.76394C5.40375 7.99769 5.47181 8.13037 5.66088 8.13037C5.79425 8.13037 5.99569 8.08225 6.1325 7.96125L6.072 8.24725C5.87469 8.48513 5.4395 8.65837 5.06481 8.65837C4.5815 8.65837 4.37594 8.36825 4.50931 7.75156L5.01669 5.36731C5.06069 5.16587 5.02081 5.093 4.81938 5.04419L4.50931 4.9885L4.56569 4.72656L6.14006 4.52925H6.13938ZM5.5 3.78125C5.31766 3.78125 5.1428 3.70882 5.01386 3.57989C4.88493 3.45095 4.8125 3.27609 4.8125 3.09375C4.8125 2.91141 4.88493 2.73655 5.01386 2.60761C5.1428 2.47868 5.31766 2.40625 5.5 2.40625C5.68234 2.40625 5.8572 2.47868 5.98614 2.60761C6.11507 2.73655 6.1875 2.91141 6.1875 3.09375C6.1875 3.27609 6.11507 3.45095 5.98614 3.57989C5.8572 3.70882 5.68234 3.78125 5.5 3.78125Z" fill="currentColor"></path>' +
    '</svg>' +
    '<div class="tooltip-content rte"><span>' + content + '</span></div>' +
    '</div>';
}

/* ─── Spec table builder ─────────────────────────────────────────────────── */

function buildFlatSpecTable(storedProducts) {
  var includeRaw = typeof window.includeAttributesForCompare === 'string'
    ? window.includeAttributesForCompare : '';
  var excludeRaw = typeof window.excludeAttributesForCompare === 'string'
    ? window.excludeAttributesForCompare : '';

  var includeList = includeRaw.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
  var excludeSet  = new Set(excludeRaw.split(',').map(function(s) { return s.trim(); }).filter(Boolean));

  var attrKeys;
  if (includeList.length > 0) {
    attrKeys = includeList.filter(function(k) {
      return !excludeSet.has(k) && !COMPARE_HEADER_ONLY_KEYS.has(k);
    });
  } else {
    var union = new Set();
    storedProducts.forEach(function(p) {
      if (p.algolia && typeof p.algolia === 'object') {
        Object.keys(p.algolia).forEach(function(k) { union.add(k); });
      }
    });
    attrKeys = Array.from(union)
      .filter(function(k) { return !excludeSet.has(k) && !COMPARE_HEADER_ONLY_KEYS.has(k); })
      .sort(function(a, b) {
        return (COMPARE_LABEL_MAP[a] ? COMPARE_LABEL_MAP[a].order : 999) -
               (COMPARE_LABEL_MAP[b] ? COMPARE_LABEL_MAP[b].order : 999);
      });
  }

  /* Single inner-compare-table — no group headers at launch.
   * GROUPING ENGINE: to enable later, group attrKeys by COMPARE_LABEL_MAP[k].group
   * and wrap each group in its own <table class="inner-compare-table"> with a
   * visible .type-title-tr row. The DOM contract below is already compatible.
   */
  var tableHtml = '<tr class="type-table-tr"><td colspan="100%">' +
    (attrKeys.length > 0 ? '<div class="compare-section-title">Comparison</div>' : '') +
    '<table class="inner-compare-table"><tbody>';

  var rowIndex = 0;
  attrKeys.forEach(function(key) {
    var entry = COMPARE_LABEL_MAP[key];
    var label = entry ? entry.label : prettifyKey(key);
    var tooltipHtml = buildTooltipHtml(key);
    var stripeClass = (rowIndex % 2 === 0) ? ' row-stripe' : '';
    rowIndex++;

    var tds = '';
    for (var i = 0; i < 4; i++) {
      var p = storedProducts[i];
      if (!p) {
        tds += '<td class="no-data">-</td>';
        continue;
      }
      var val = (p.algolia && p.algolia[key] != null && p.algolia[key] !== '') ? p.algolia[key] : null;
      /* Best For / Why This is Better slots (C6.1/C6.2) — empty at launch */
      var noteBoxHtml = '';  /* TODO: populate from content metafield when client adds data */
      if (val != null) {
        tds += '<td class="data">' + escapeHtml(val) + noteBoxHtml + '</td>';
      } else {
        tds += '<td class="no-data">-</td>';
      }
    }

    var labelSafe = escapeHtml(label);
    tableHtml +=
      '<tr class="data-tr only-title large-up-hide medium-hide' + stripeClass + '">' +
        '<th class="first-th">' + labelSafe + tooltipHtml + '</th>' +
      '</tr>' +
      '<tr class="data-tr' + stripeClass + '" data-chktitle="' + labelSafe + '">' +
        '<th class="first-th small-hide">' + labelSafe + tooltipHtml + '</th>' +
        tds +
      '</tr>';
  });

  tableHtml += '</tbody></table></td></tr>';

  document.querySelector('.product-compare .compare-table tbody').innerHTML += tableHtml;
  card_EqualHeight();

  /* Restore ShowDiff state */
  var get_diff_val = localStorage.getItem('ShowDiff');
  var diff_selector;
  if (window.outerWidth > 898) {
    diff_selector = document.querySelector('.compare-table .compare-checkbox [onchange="checkDiff(this)"]');
  } else {
    diff_selector = document.querySelector('.page-header .compare-checkbox [onchange="checkDiff(this)"]');
  }
  if (get_diff_val !== null && diff_selector) {
    if (get_diff_val === 'true' && diff_selector.checked === false) {
      diff_selector.click();
    }
  }
}

/* ─── Empty state ───────────────────────────────────────────────────────────
 * Shared by Clear All and by removing the last product. Both used to call
 * BrowseProd(), which navigated away from the compare page — see the header
 * comment on BrowseProd for why that sent people to an unrelated collection.
 */
function compareEmptyColumnHtml() {
  return '<th class="empty-th">' +
      '<div class="product-card product-card-empty">' +
        '<p class="link" onclick="BrowseProd()">Browse Products' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" class="icon icon-arrow">' +
            '<path d="M2.34375 7.5H12.6562" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '<path d="M8.4375 3.28125L12.6562 7.5L8.4375 11.7188" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '</svg>' +
        '</p>' +
        '<span>You can select up to 4 products for comparison</span>' +
      '</div>' +
    '</th>';
}

function renderCompareEmptyState() {
  var tbody = document.querySelector('.compare-table tbody');
  if (tbody) tbody.querySelectorAll('.type-table-tr').forEach(function(tr) { tr.remove(); });

  var headerRow = document.querySelectorAll('.product-compare .compare-table table .product-card-tr')[1];
  if (headerRow) {
    var html =
      '<th class="first-th small-hide">' +
        '<div class="compare-count"><span class="c-count">0 of 4</span> selected</div>' +
        '<label class="compare-checkbox">' +
          '<input type="checkbox" onchange="checkDiff(this)"> Only Show Differences' +
        '</label>' +
      '</th>';
    for (var i = 0; i < 4; i++) html += compareEmptyColumnHtml();
    headerRow.innerHTML = html;
  }

  document.querySelectorAll('.compare-count .c-count').forEach(function(el) { el.textContent = '0 of 4'; });
  document.querySelectorAll('.compare-checkbox [onchange="checkDiff(this)"]').forEach(function(cb) { cb.checked = false; });
  localStorage.removeItem('ShowDiff');
}

/* ─── Compare page column builder ───────────────────────────────────────── */

function CheckCompareProducts() {
  if (localStorage.getItem('allProducts') === null || document.body.classList.contains('template-cart')) return;

  var storedProducts = JSON.parse(localStorage.getItem('allProducts'));

  if (document.body.classList.contains('compare-p')) {
    if (storedProducts.length === 0) { renderCompareEmptyState(); return; }

    /* Build header row */
    var headerRow = document.querySelectorAll('.product-compare .compare-table table .product-card-tr')[1];
    headerRow.innerHTML =
      '<th class="first-th small-hide">' +
        '<div class="compare-count"><span class="c-count">' + storedProducts.length + ' of 4</span> selected</div>' +
        '<label class="compare-checkbox">' +
          '<input type="checkbox" onchange="checkDiff(this)"> Only Show Differences' +
        '</label>' +
      '</th>';

    storedProducts.forEach(function(product, i) {
      var priceHtml;
      if (product.comparePrice != null) {
        priceHtml =
          '<div class="price-wrap">' +
          '<div class="price price--on-sale"><dl>' +
          '<div class="price__sale">' +
          '<dd><span class="price-item price-item--sale">' + escapeHtml(product.price) + '</span></dd>' +
          '</div>' +
          '<dd class="price__compare"><s class="price-item price-item--regular">' + escapeHtml(product.comparePrice) + '</s></dd>' +
          '</dl></div></div>';
      } else if (product.price && product.price != 0) {
        priceHtml =
          '<div class="price-wrap"><div class="price"><dl>' +
          '<div class="price__regular">' +
          '<dd><span class="price-item price-item--regular">' + escapeHtml(product.price) + '</span></dd>' +
          '</div></dl></div></div>';
      } else {
        priceHtml = '<div class="price-wrap empty"><div class="price"><dl>' +
          '<div class="price__regular"><dd><span class="price-item price-item--regular"></span></dd></div>' +
          '</dl></div></div>';
      }

      var mpn = (product.algolia && product.algolia.mpn) ? product.algolia.mpn : '';
      var skuHtml = (product.sku || mpn) ?
        '<p class="card__sku">' +
        (product.sku ? 'SKU: ' + escapeHtml(product.sku) : '') +
        (product.sku && mpn ? '<span class="sku-sep"> | </span>' : '') +
        (mpn ? 'MPN: ' + escapeHtml(mpn) : '') +
        '</p>' : '';

      var badge   = (product.algolia && product.algolia.badge)    ? product.algolia.badge    : '';
      var bestFor = (product.algolia && product.algolia.best_for) ? product.algolia.best_for : '';
      var badgesHtml =
        '<div class="compare-card-badges">' +
          (badge   ? '<span class="compare-badge-avail">' + escapeHtml(badge)   + '</span>' : '') +
          (bestFor ? '<span class="compare-best-for">'   + escapeHtml(bestFor)  + '</span>' : '') +
        '</div>';

      /* Availability badge (C4.9) — default to unknown until /products/{handle}.js fetch */
      var availClass = 'out-of-stock';
      var availLabel = 'Check availability';
      if (product.algolia && product.algolia.availability) {
        var avail = product.algolia.availability.toLowerCase();
        if (avail === 'in stock' || avail === 'available') {
          availClass = 'in-stock';
          availLabel = 'In Stock';
        } else {
          availLabel = product.algolia.availability;
        }
      }
      var availHtml = '<div class="compare-availability ' + availClass + '">' +
        '<span class="badge-dot"></span>' + escapeHtml(availLabel) + '</div>';

      /* Variant selector placeholder — populated after /products/{handle}.js fetch */
      var variantHtml = '<div class="compare-variant-wrap" data-handle="' + escapeHtml(product.handle) + '" data-column="' + i + '"></div>';

      var handleSafe = escapeHtml(product.handle);
      var idSafe     = escapeHtml(product.id);
      var vidSafe    = escapeHtml(product.vid);
      var titleSafe  = escapeHtml(product.title);
      var brandSafe  = escapeHtml(product.brand);
      var imageSafe  = escapeHtml(product.image);

      headerRow.innerHTML +=
        '<th class="card-th">' +
        '<div class="product-card--placeholder"></div>' +
        '<div class="product-card card-wrapper" data-product="' + handleSafe + '">' +
          '<span class="remove-product" onclick="removeCompareItem(this)" data-id="' + idSafe + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="icon icon-close">' +
            '<path d="M12.5 3.5L3.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '<path d="M12.5 12.5L3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '</svg>' +
          '</span>' +
          badgesHtml +
          '<div class="card card--product">' +
            '<a href="/products/' + handleSafe + '" class="media media--hover-effect" aria-label="Product link" style="padding-bottom: ;">' +
              '<img src="' + imageSafe + '" alt="' + titleSafe + '" width="3474" loading="lazy" class="motion-reduce media--first" style="object-position: 50% 50%; object-fit: contain;">' +
            '</a>' +
          '</div>' +
          '<div class="card-information">' +
            '<div class="card-information__wrapper">' +
              '<div class="card-information-block">' +
                '<p class="compare-card-brand">' + brandSafe + '</p>' +
                '<h3 class="card__title">' +
                  '<a class="unstyled-link" href="/products/' + handleSafe + '">' + titleSafe + '</a>' +
                '</h3>' +
                skuHtml +
                availHtml +
                priceHtml +
                variantHtml +
              '</div>' +
              '<product-form class="card__add-to-cart card__button">' +
                '<form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">' +
                  '<input type="hidden" name="form_type" value="product">' +
                  '<input type="hidden" name="utf8" value="✓">' +
                  '<input type="hidden" name="id" value="' + vidSafe + '" class="compare-variant-id">' +
                  '<input type="hidden" name="quantity" value="1">' +
                  '<button id="' + idSafe + '-id" type="button" data-id="' + idSafe + '" onclick="add_cart_cmp(this)" ' +
                    'class="add_cart_cmp _card__link btn btn--primary card-focused" name="add">' +
                    '<span class="card__quickview-text btn__text">Add to Cart</span>' +
                    '<span class="sold-out-message btn__text hidden">Sold Out</span>' +
                    '<b class="loading-overlay__spinner hidden">' +
                      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                        '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                      '</svg>' +
                    '</b>' +
                  '</button>' +
                '</form>' +
              '</product-form>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<a class="card-link--overlay" href="/products/' + handleSafe + '" aria-label="Product link"></a>' +
        '</th>';

      /* Fill empty columns */
      if (i === storedProducts.length - 1) {
        var remaining = 4 - storedProducts.length;
        for (var j = 0; j < remaining; j++) {
          headerRow.innerHTML += compareEmptyColumnHtml();
        }

        document.querySelectorAll('.product-compare .compare-count .c-count').forEach(function(el) {
          el.textContent = storedProducts.length + ' of 4';
        });

        /* Build spec table from algolia_data — no AJAX fetch needed */
        buildFlatSpecTable(storedProducts);

        /* Fetch /products/{handle}.js for each column to populate variant selector + availability */
        storedProducts.forEach(function(product, colIdx) {
          loadProductVariants(product, colIdx);
        });

        syncScroll();
      }
    });

  } else {
    /* Non-compare page: rebuild tray from localStorage */
    if (storedProducts.length === 0) return;

    var content = document.querySelector('.compare-float--content');
    if (!content) return;
    content.innerHTML = '';

    storedProducts.forEach(function(p, i) {
      content.innerHTML +=
        '<div class="compare-float--item">' +
          '<span class="remove-compare-item" onclick="removeProduct(this)" data-id="' + escapeHtml(p.id) + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
              '<path d="M12.5 3.5L3.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '<path d="M12.5 12.5L3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>' +
          '<div class="comFloat-item--image"><img src="' + escapeHtml(p.image) + '" loading="lazy" width="70" height="70" alt=""></div>' +
          '<div class="comFloat-item--content">' +
            '<h6 class="comFloat-item--title p-brand">' + escapeHtml(p.brand) + '</h6>' +
            '<h6 class="comFloat-item--title p-title">' + escapeHtml(p.title) + '</h6>' +
            '<span class="comFloat-item--sku">' + escapeHtml(p.sku || '') + '</span>' +
          '</div>' +
        '</div>';

      if (i === storedProducts.length - 1) {
        var remaining = 4 - storedProducts.length;
        for (var j = 0; j < remaining; j++) {
          content.innerHTML += '<div class="compare-float--item item-empty"><span>You can select up to 4 products</span></div>';
        }
        var countEl = document.querySelector('.nO--added');
        if (countEl) countEl.textContent = '(' + storedProducts.length + '/4 Added)';

        document.querySelector('.compare-bottom-wrap').classList.remove('hidden');
        if (!document.querySelector('.compare-bottom-wrap').classList.contains('hide-chat')) {
          document.querySelector('.compare-bottom-wrap').classList.add('hide-chat');
        }

        /* Suggestions when exactly 1 product selected */
        if (storedProducts.length === 1) {
          fetchCompareAlgoliaSuggestions(storedProducts[0]);
        } else {
          var suggEl = document.querySelector('.compare-float--suggestion');
          if (suggEl) { suggEl.classList.add('hidden'); suggEl.classList.remove('show'); }
        }

        document.body.classList.remove('compare--loading');
        bottomActiveTabs();
        setEqualHeight();
      }
    });
  }
}

/* ─── Variant loader (C4.8) ─────────────────────────────────────────────── */

var compareProductCache = {};

function loadProductVariants(product, colIdx) {
  if (compareProductCache[product.handle]) {
    renderVariantSelector(compareProductCache[product.handle], product, colIdx);
    return;
  }
  fetch('/products/' + product.handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      compareProductCache[product.handle] = data;
      renderVariantSelector(data, product, colIdx);
    })
    .catch(function(err) { console.error('Variant fetch error:', err); });
}

function renderVariantSelector(data, product, colIdx) {
  if (!data.variants || data.variants.length <= 1) return;

  var _fmt = typeof FoxTheme !== 'undefined' && FoxTheme.Currency
    ? function(p) { return FoxTheme.Currency.formatMoney(p, window.theme && window.theme.moneyFormat); }
    : function(p) { return '$' + (p / 100).toFixed(2); };

  var chevronSvg =
    '<svg class="cvs-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<path d="M2.5 5L7 9.5L11.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function buildDropdown() {
    var wrap = document.createElement('div');
    wrap.className = 'compare-variant-select';
    wrap.dataset.column = colIdx;
    wrap.dataset.handle = product.handle;

    var optionsHtml = '';
    data.variants.forEach(function(v) {
      var sel = String(v.id) === String(product.vid) ? ' cvs-selected' : '';
      optionsHtml +=
        '<div class="cvs-option' + sel + '"' +
          ' data-value="' + escapeHtml(v.id) + '"' +
          ' data-price="' + escapeHtml(_fmt(v.price)) + '"' +
          ' data-compare-at="' + (v.compare_at_price ? escapeHtml(_fmt(v.compare_at_price)) : '') + '"' +
          ' data-available="' + escapeHtml(v.available) + '">' +
          '<span class="cvs-option-text">' + escapeHtml(v.title) + '</span>' +
        '</div>';
    });

    var currentVariant = data.variants.find(function(v) { return String(v.id) === String(product.vid); }) || data.variants[0];

    wrap.innerHTML =
      '<div class="cvs-trigger">' +
        '<span class="cvs-current">' + escapeHtml(currentVariant.title) + '</span>' +
        chevronSvg +
      '</div>' +
      '<div class="cvs-list">' + optionsHtml + '</div>';

    wrap.querySelector('.cvs-trigger').addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = wrap.classList.contains('cvs-open');
      document.querySelectorAll('.compare-variant-select.cvs-open').forEach(function(el) {
        el.classList.remove('cvs-open');
      });
      if (!isOpen) wrap.classList.add('cvs-open');
    });

    wrap.querySelectorAll('.cvs-option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var newVid = this.dataset.value;
        wrap.querySelector('.cvs-current').textContent = this.textContent;
        wrap.querySelectorAll('.cvs-option').forEach(function(o) { o.classList.remove('cvs-selected'); });
        this.classList.add('cvs-selected');
        wrap.classList.remove('cvs-open');
        applyVariantChange(colIdx, newVid, this.dataset.price, this.dataset.compareAt, this.dataset.available === 'true');
        /* Sync sibling dropdowns (e.g. sticky header) */
        document.querySelectorAll('.compare-variant-select[data-column="' + colIdx + '"]').forEach(function(sibling) {
          if (sibling === wrap) return;
          sibling.querySelector('.cvs-current').textContent = opt.textContent;
          sibling.querySelectorAll('.cvs-option').forEach(function(o) {
            o.classList.toggle('cvs-selected', o.dataset.value === newVid);
          });
        });
      });
    });

    return wrap;
  }

  document.querySelectorAll('.compare-variant-wrap[data-column="' + colIdx + '"]').forEach(function(wrapEl) {
    wrapEl.appendChild(buildDropdown());
  });

  /* Close all dropdowns on outside click */
  if (!window._cvsOutsideClickBound) {
    window._cvsOutsideClickBound = true;
    document.addEventListener('click', function() {
      document.querySelectorAll('.compare-variant-select.cvs-open').forEach(function(el) {
        el.classList.remove('cvs-open');
      });
    });
  }
}

function applyVariantChange(colIdx, newVid, price, compareAt, isAvailable) {
  /* Update hidden variant id input in cart form */
  var cardThs = document.querySelectorAll('.product-compare .compare-table table .product-card-tr')[1];
  if (!cardThs) return;
  var th = cardThs.querySelectorAll('.card-th')[colIdx];
  if (!th) return;

  var vidInput = th.querySelector('.compare-variant-id');
  if (vidInput) vidInput.value = newVid;

  /* Update price */
  var priceEl = th.querySelector('.price-item--sale, .price-item--regular');
  if (priceEl) priceEl.textContent = price;
  var compareEl = th.querySelector('.price__compare .price-item--regular');
  if (compareEl && compareAt) compareEl.textContent = compareAt;

  /* Update availability badge */
  var badge = th.querySelector('.compare-availability');
  if (badge) {
    badge.className = 'compare-availability ' + (isAvailable ? 'in-stock' : 'out-of-stock');
    var textNode = badge.childNodes[badge.childNodes.length - 1];
    if (textNode) textNode.textContent = isAvailable ? 'In Stock' : 'Out of Stock';
  }
}

/* ─── Algolia suggestions (C3.2) ────────────────────────────────────────── */

function fetchCompareAlgoliaSuggestions(seedProduct) {
  /* algoliasearch UMD is always loaded globally via algolia_algoliasearch-lite.umd.js */
  if (typeof algoliasearch === 'undefined') return;
  if (!window.algoliaShopify || !window.algoliaShopify.config) return;

  var cfg = window.algoliaShopify.config;
  var client = algoliasearch(cfg.app_id, cfg.search_api_key);
  var index = client.initIndex(cfg.index_prefix);
  var seedId = seedProduct.vid || seedProduct.id;

  /* Filter: same collection if available, optionally boost same brand */
  var algData = seedProduct.algolia || {};
  var brand = seedProduct.brand || '';
  var filters = 'NOT objectID:"' + seedId + '"';

  if (typeof algolia_customs !== 'undefined' && algolia_customs.collection && algolia_customs.handle) {
    filters += ' AND collections:' + algolia_customs.handle;
  }

  /* Catalogue visibility — same filter the main grid applies. The helper
   * parenthesises its OR, so ANDing it here cannot split the expression. */
  filters += ' AND ' + (function () {
        if (typeof window.jendcoB2BFilter === 'function') return window.jendcoB2BFilter();
        var l = window.algoliaB2B && (window.algoliaB2B.locationId || window.algoliaB2B.rawLocationId);
        var a = 'meta.custom.b2b_location_ids';
        return ['tags:"b2b-only"', a + ':"restricted"'].map(function (m) {
          return l ? '(NOT ' + m + ' OR ' + a + ':"' + l + '")' : 'NOT ' + m;
        }).join(' AND ');
      })();

  index.search('', {
    filters: filters,
    optionalFilters: brand ? ['vendor:"' + brand + '"'] : [],
    hitsPerPage: 3
  }).then(function(result) {
    var hits = result.hits || [];
    if (hits.length === 0) return;

    var suggContent = document.querySelector('.compare-float--suggestion .comFloat-sugg--content');
    var suggWrap = document.querySelector('.compare-float--suggestion');
    if (!suggContent || !suggWrap) return;

    var html = '';
    hits.forEach(function(hit) {
      var algoliaStr = '';
      try { algoliaStr = escapeHtml(JSON.stringify(hit.meta && hit.meta.custom && hit.meta.custom.algolia_data || {})); } catch(e) {}
      var title = (hit._highlightResult && hit._highlightResult.title) ? hit._highlightResult.title.value : hit.title;
      var titleSafe = escapeHtml(title);
      var vendorSafe = escapeHtml(hit.vendor || '');
      var skuVal = (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data && hit.meta.custom.algolia_data.sku) || '';
      var skuSafe = escapeHtml(skuVal);
      var priceVal = typeof FoxTheme !== 'undefined' && FoxTheme.Currency
        ? FoxTheme.Currency.formatMoney((hit.price || 0) * 100, window.theme && window.theme.moneyFormat)
        : (hit.price || 0);
      html +=
        '<div class="compare-float--item comFloat-item--sugg">' +
          '<div class="comFloat-item--image"><img src="' + escapeHtml(hit.image || '') + '" loading="lazy" width="70" height="70" alt=""></div>' +
          '<div class="comFloat-item--content">' +
            '<span class="comFloat-item--brand">' + vendorSafe + '</span>' +
            '<h6 class="comFloat-item--title">' + titleSafe + '</h6>' +
            '<span class="comFloat-item--sku">' + skuSafe + '</span>' +
            '<label class="compare_product" onclick="addCompare(event,this,true)"' +
              ' data-id="' + escapeHtml(hit.id) + '"' +
              ' data-vid="' + escapeHtml(hit.objectID) + '"' +
              ' data-handle="' + escapeHtml(hit.handle) + '"' +
              ' data-brand="' + vendorSafe + '"' +
              ' data-title="' + titleSafe + '"' +
              ' data-sku="' + skuSafe + '"' +
              ' data-image="' + escapeHtml(hit.image || '') + '"' +
              ' data-price="' + escapeHtml(priceVal) + '"' +
              ' data-algolia=\'' + algoliaStr + '\'>' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">' +
                '<path d="M2.34375 7.5H12.6562" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                '<path d="M7.5 2.34375V12.6562" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
              '<span>Add to compare</span>' +
            '</label>' +
          '</div>' +
        '</div>';
    });

    suggContent.innerHTML = html;
    suggWrap.classList.remove('hidden');
    suggWrap.classList.add('show');
    setEqualHeight();
    if (document.body.classList.contains('compare-p')) syncScroll();
  }).catch(function(err) { console.warn('Algolia suggestions error:', err); });
}

/* ─── Add / remove compare ───────────────────────────────────────────────── */

function addCompare(e, element, c_btn) {
  if (c_btn === undefined) c_btn = false;
  e.preventDefault();

  /* Parse algolia data from data attribute (Phase 3 injects this) */
  var algoliaSrc = element.getAttribute('data-algolia');
  var algoliaData = {};
  if (algoliaSrc) {
    try { algoliaData = JSON.parse(algoliaSrc); } catch(e) {}
  }

  var currentProductData = {
    id:           element.getAttribute('data-id') || (element.closest('.product-grid-box') && element.closest('.product-grid-box').getAttribute('data-id')) || '',
    handle:       element.getAttribute('data-handle') || (element.closest('.product-grid-box') && element.closest('.product-grid-box').querySelector('.product-grid-link') && element.closest('.product-grid-box').querySelector('.product-grid-link').getAttribute('href').split('/products/')[1]) || '',
    image:        element.getAttribute('data-image') || (element.closest('.product-grid-box') && element.closest('.product-grid-box').querySelector('img') && element.closest('.product-grid-box').querySelector('img').getAttribute('src')) || '',
    brand:        element.getAttribute('data-brand') || (element.closest('.product-grid-box') && element.closest('.product-grid-box').querySelector('.pro-brand') && element.closest('.product-grid-box').querySelector('.pro-brand').textContent) || '',
    title:        element.getAttribute('data-title') || (element.closest('.product-grid-box') && element.closest('.product-grid-box').querySelector('.product-grid-title') && element.closest('.product-grid-box').querySelector('.product-grid-title').textContent) || '',
    sku:          element.getAttribute('data-sku') || '',
    vid:          element.getAttribute('data-vid') || '',
    price:        element.getAttribute('data-price') || '0',
    comparePrice: element.getAttribute('data-compareprice') || element.getAttribute('data-comparePrice') || null,
    algolia:      algoliaData
  };

  var productId = currentProductData.id;
  var storedProducts = localStorage.getItem('allProducts') !== null
    ? JSON.parse(localStorage.getItem('allProducts')) : [];
  var foundProduct = storedProducts.find(function(p) { return p.id === productId; });

  if (foundProduct) {
    /* Deselect: remove from storage and tray, then sync checkboxes.
       Must run before the limit check below — an already-selected
       product must always be removable, even when the tray is full. */
    var trayRemoveEl = document.querySelector('.remove-compare-item[data-id="' + productId + '"]');
    if (trayRemoveEl) {
      removeProduct(trayRemoveEl);
    } else {
      storedProducts.splice(storedProducts.indexOf(foundProduct), 1);
      localStorage.setItem('allProducts', JSON.stringify(storedProducts));
      setTimeout(reapplyCompareChecked, 0);
    }
    return;
  }

  /* Limit check — only blocks adding a genuinely new product */
  if (document.querySelectorAll('.compare-float--content .item-empty').length === 0) {
    document.querySelector('.compare-bottom-wrap').classList.remove('hidden');
    document.querySelector('.compare-bottom-wrap .compare-error').classList.remove('hidden');
    document.querySelector('.compare-bottom-wrap').classList.add('active');
    tabBottomPostion();
    return;
  }

  storedProducts.push(currentProductData);
  localStorage.setItem('allProducts', JSON.stringify(storedProducts));
  appendItemHTML(element, currentProductData);

  /* Show suggestions when exactly 1 product in tray */
  var filledCount = document.querySelectorAll('.compare-float--content .compare-float--item:not(.item-empty)').length;
  if (filledCount === 1) {
    fetchCompareAlgoliaSuggestions(currentProductData);
  } else {
    var suggEl = document.querySelector('.compare-float--suggestion');
    if (suggEl) { suggEl.classList.add('hidden'); suggEl.classList.remove('show'); }
  }

  /* Sync checkbox state on card (deferred past the browser's native
     post-click checkbox activation, which otherwise clobbers this) */
  setTimeout(reapplyCompareChecked, 0);
}

function appendItemHTML(element, productData) {
  var wrap = document.querySelector('.compare-bottom-wrap');
  if (!wrap) return;
  if (!wrap.classList.contains('hide-chat')) wrap.classList.add('hide-chat');

  var id    = productData ? productData.id    : (element.getAttribute('data-id') || '');
  var image = productData ? productData.image : (element.getAttribute('data-image') || '');
  var brand = productData ? productData.brand : (element.getAttribute('data-brand') || '');
  var title = productData ? productData.title : (element.getAttribute('data-title') || '');
  var sku   = productData ? productData.sku   : (element.getAttribute('data-sku') || '');

  var emptySlots = document.querySelectorAll('.compare-float--content .item-empty');
  if (emptySlots.length > 0) {
    emptySlots[0].innerHTML =
      '<span class="remove-compare-item" onclick="removeProduct(this)" data-id="' + escapeHtml(id) + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
          '<path d="M12.5 3.5L3.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M12.5 12.5L3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<div class="comFloat-item--image"><img src="' + escapeHtml(image) + '" loading="lazy" width="70" height="70" alt=""></div>' +
      '<div class="comFloat-item--content">' +
        '<h6 class="comFloat-item--title p-brand">' + escapeHtml(brand) + '</h6>' +
        '<h6 class="comFloat-item--title p-title">' + escapeHtml(title) + '</h6>' +
        '<span class="comFloat-item--sku">' + escapeHtml(sku) + '</span>' +
      '</div>';
    emptySlots[0].classList.remove('item-empty');
  } else {
    wrap.querySelector('.compare-error').classList.remove('hidden');
  }

  /* Auto-open bar when a product is added */
  var toggleEl = wrap.querySelector('[data-toggle-text]');
  if (toggleEl) {
    toggleEl.setAttribute('data-toggle-text', 'Hide');
    toggleEl.textContent = 'Hide';
  }
  wrap.classList.add('active');

  var filled = document.querySelectorAll('.compare-bottom-wrap .compare-float--content .compare-float--item:not(.item-empty)').length;
  var countEl = document.querySelector('.nO--added');
  if (countEl) countEl.textContent = '(' + filled + '/4 Added)';

  var infoEl = document.querySelector('.info-add-pro.order-last');
  if (infoEl) infoEl.classList.toggle('hidden', filled === 4);

  bottomActiveTabs();
  setTimeout(function() { tabBottomPostion(); }, 100);
}

function removeProduct(element) {
  var wrap = document.querySelector('.compare-bottom-wrap');
  var errEl = wrap && wrap.querySelector('.compare-error');
  if (errEl && !errEl.classList.contains('hidden')) errEl.classList.add('hidden');

  if (localStorage.getItem('allProducts') !== null) {
    var storedProducts = JSON.parse(localStorage.getItem('allProducts'));
    var productId = element.getAttribute('data-id');
    var idx = storedProducts.findIndex(function(p) { return p.id === productId; });
    if (idx !== -1) {
      storedProducts.splice(idx, 1);
      localStorage.setItem('allProducts', JSON.stringify(storedProducts));
    }
  }

  var parent = element.closest('.compare-float--content');
  element.closest('.compare-float--item').remove();
  if (parent) parent.innerHTML += '<div class="compare-float--item item-empty"><span>You can select up to 4 products</span></div>';

  if (wrap && wrap.classList.contains('compare-added-full')) wrap.classList.remove('compare-added-full');

  var filled = document.querySelectorAll('.compare-bottom-wrap .compare-float--content .compare-float--item:not(.item-empty)').length;
  var countEl = document.querySelector('.nO--added');
  if (countEl) countEl.textContent = '(' + filled + '/4 Added)';

  if (filled === 0) {
    if (wrap) {
      wrap.classList.remove('active', 'hide-chat');
      wrap.classList.add('hidden');
    }
    var toggleEl = document.querySelector('[data-toggle-text]');
    if (toggleEl) { toggleEl.setAttribute('data-toggle-text', 'Show'); toggleEl.textContent = 'Show'; }
    localStorage.removeItem('ShowDiff');
  } else if (filled === 1) {
    var avail_data = JSON.parse(localStorage.getItem('allProducts'));
    if (avail_data && avail_data[0]) fetchCompareAlgoliaSuggestions(avail_data[0]);
  }

  var infoEl = document.querySelector('.info-add-pro.order-last');
  if (infoEl) infoEl.classList.toggle('hidden', filled === 4);

  bottomActiveTabs();
  tabBottomPostion();
  setTimeout(reapplyCompareChecked, 0);
}

function goToCompare() {
  window.location.href = '/pages/compare?view=compare-p';
}

function clearCompare() {
  document.querySelectorAll('.compare-float--content .compare-float--item:not(.item-empty)').forEach(function(el) {
    el.innerHTML = '<span>You can select up to 4 products</span>';
    el.classList.add('item-empty');
  });
  var wrap = document.querySelector('.compare-bottom-wrap');
  if (wrap) {
    wrap.classList.remove('compare-added-full', 'active', 'hide-chat');
    wrap.classList.add('hidden');
  }
  var countEl = document.querySelector('.nO--added');
  if (countEl) countEl.textContent = '(0/4 Added)';
  localStorage.removeItem('allProducts');
  bottomActiveTabs();
  tabBottomPostion();
  setTimeout(reapplyCompareChecked, 0);
}

function clearComparePage() {
  localStorage.removeItem('allProducts');
  renderCompareEmptyState();
}

function removeCompareItem(element) {
  if (localStorage.getItem('allProducts') !== null) {
    var storedProducts = JSON.parse(localStorage.getItem('allProducts'));
    var productId = element.getAttribute('data-id');
    var idx = storedProducts.findIndex(function(p) { return p.id === productId; });
    if (idx !== -1) {
      storedProducts.splice(idx, 1);
      localStorage.setItem('allProducts', JSON.stringify(storedProducts));
      document.querySelector('.compare-table tbody').querySelectorAll('.type-table-tr').forEach(function(tr) { tr.remove(); });
      CheckCompareProducts();
    }
  }
}

/* ─── Toggle widget ─────────────────────────────────────────────────────── */

function toggleWidget(element) {
  var wrap = element.closest('.compare-bottom-wrap');
  if (!wrap) return;

  var errEl = wrap.querySelector('.compare-error');
  if (errEl && !errEl.classList.contains('hidden')) errEl.classList.add('hidden');

  var toggleEl = element.querySelector('[data-toggle-text]');
  if (toggleEl) {
    if (toggleEl.getAttribute('data-toggle-text') === 'Hide') {
      toggleEl.setAttribute('data-toggle-text', 'Show');
      toggleEl.textContent = 'Show';
    } else {
      toggleEl.setAttribute('data-toggle-text', 'Hide');
      toggleEl.textContent = 'Hide';
    }
  }

  wrap.classList.toggle('active');
  setTimeout(function() { tabBottomPostion(); }, 50);
}

/* ─── Show differences ──────────────────────────────────────────────────── */

function checkDiff(ele) {
  var table = document.querySelector('.compare-table table');
  if (!table) return;

  table.querySelectorAll('tr.data-tr[data-chktitle]').forEach(function(row) {
    if (row.classList.contains('type-title-tr')) return;

    var cells = Array.from(row.querySelectorAll('td, th')).slice(1);
    var values = cells.map(function(cell) { return cell.textContent.trim().toLowerCase(); })
                      .filter(function(v) { return v !== '-' && v !== ''; });

    var allSame = values.length > 1 && values.every(function(v) { return v === values[0]; });

    if (ele.checked) {
      row.style.display = allSame ? 'none' : '';
      var prev = row.previousElementSibling;
      if (prev && prev.classList.contains('only-title')) prev.style.display = allSame ? 'none' : '';
    } else {
      row.style.display = '';
      var prev = row.previousElementSibling;
      if (prev && prev.classList.contains('only-title')) prev.style.display = '';
    }
  });

  /* Hide/show group headers when all rows in group are hidden */
  table.querySelectorAll('table.inner-compare-table tbody>.type-title-tr').forEach(function(headerRow) {
    var groupRows = headerRow.closest('tbody').querySelectorAll('tr.data-tr');
    var anyVisible = Array.from(groupRows).some(function(r) {
      return window.getComputedStyle(r).display !== 'none';
    });
    if (ele.checked) {
      headerRow.style.display = anyVisible ? '' : 'none';
    } else {
      headerRow.style.display = '';
    }
  });

  /* Hide/show "Comparison" title when all data rows are hidden */
  var titleEl = table.querySelector('.compare-section-title');
  if (titleEl) {
    if (ele.checked) {
      var anyDataVisible = Array.from(table.querySelectorAll('tr.data-tr[data-chktitle]'))
        .some(function(r) { return window.getComputedStyle(r).display !== 'none'; });
      titleEl.style.display = anyDataVisible ? '' : 'none';
    } else {
      titleEl.style.display = '';
    }
  }

  /* Sync both checkboxes */
  var otherSelector = window.outerWidth > 898
    ? '.page-header .compare-checkbox [onchange="checkDiff(this)"]'
    : '.compare-table .compare-checkbox [onchange="checkDiff(this)"]';
  var other = document.querySelector(otherSelector);
  if (other && other !== ele) other.checked = ele.checked;

  localStorage.setItem('ShowDiff', ele.checked);
}

/* ─── Sticky header scroll ──────────────────────────────────────────────── */

function windowScrollCP() {
  /* Jendco uses <sticky-header> custom element (no .header-wrapper class) */
  var headerEl = document.querySelector('sticky-header') || document.querySelector('header');
  var headerHeight = headerEl ? headerEl.offsetHeight : 0;

  var element = document.querySelector('.product-card-tr:not(.product-card-tr-placeholder)');
  var placeholder = document.querySelector('.product-card-tr.product-card-tr-placeholder');
  if (!element || !placeholder) return;

  var top1 = element.getBoundingClientRect().top;
  var top2 = placeholder.getBoundingClientRect().top;
  var offTop  = (top1 + 411) - headerHeight;
  var offTop2 = (top2 + 411) - headerHeight;
  var hasClass = element.classList.contains('header-fixed');

  if (offTop < 149 && !hasClass) {
    placeholder.style.minHeight = element.offsetHeight + 'px';
    element.classList.add('header-fixed');
    placeholder.classList.remove('hidden');
  } else if (offTop2 > 150 && hasClass) {
    element.classList.remove('header-fixed');
    placeholder.classList.add('hidden');
    placeholder.style.minHeight = '';
  }

  if (hasClass) {
    var mainParent = document.querySelector('.product-compare');
    var mpTop      = mainParent.getBoundingClientRect().top;
    var mpOffset   = mainParent.offsetTop * 2;
    var mpOffsetH  = mainParent.offsetHeight;
    var fixedH     = element.offsetHeight;
    var diff       = mpOffsetH - (Math.abs(mpTop) + mpOffset + fixedH);
    var hasVisi    = element.classList.contains('visibility-hidden');
    if (diff < 50 && !hasVisi)  element.classList.add('visibility-hidden');
    else if (diff > 50 && hasVisi) element.classList.remove('visibility-hidden');
  }
}

function syncScroll() {
  var fixedDiv = document.querySelector('.product-card-tr:not(.product-card-tr-placeholder)');
  var syncDiv  = document.querySelector('.compare-table');
  if (!fixedDiv || !syncDiv) return;

  var syncing = false;
  fixedDiv.addEventListener('scroll', function() {
    if (syncing) return;
    syncing = true;
    syncDiv.scrollLeft = fixedDiv.scrollLeft;
    syncing = false;
  });
  syncDiv.addEventListener('scroll', function() {
    if (syncing) return;
    syncing = true;
    fixedDiv.scrollLeft = syncDiv.scrollLeft;
    syncing = false;
  });
}

function card_EqualHeight() {
  /* min-height equalization removed — titles size naturally */
}

/* ─── Add to cart from compare (C4.5) ──────────────────────────────────── */

function add_cart_cmp(ele) {
  var fetchConfigFn = FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig;
  if (!fetchConfigFn) { location.reload(); return; }

  var config = fetchConfigFn('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = new FormData(ele.closest('form'));

  fetch(FoxTheme.routes.cart_add_url, config)
    .then(function(r) { return r.json(); })
    .then(function(parsedState) {
      if (parsedState.status) {
        console.error('Add to cart error:', parsedState.description || parsedState.message);
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    })
    .catch(function(err) { console.error('Add to cart error:', err); });
}

/* ─── Browse redirect ───────────────────────────────────────────────────── */

function BrowseProd() {
  /* Reads the value breadcrumbs.liquid actually writes. This used to read
   * localStorage 'CollectionLink', a key nothing in the theme has ever set —
   * so it either fell through to /collections/all or, on browsers carrying a
   * leftover key from an older build, navigated to a long-stale collection. */
  var saved = sessionStorage.getItem('lastCollectionUrl');
  window.location.href = saved || '/collections/all';
}

/* ─── Checkbox re-apply after Algolia re-render ─────────────────────────── */

function reapplyCompareChecked() {
  var stored = localStorage.getItem('allProducts');
  var ids = stored ? new Set(JSON.parse(stored).map(function(p) { return p.id; })) : new Set();
  document.querySelectorAll('label.compare_product[data-id]').forEach(function(label) {
    var id = label.getAttribute('data-id');
    var checkbox = label.querySelector('input[type="checkbox"]');
    if (checkbox) {
      var inSet = ids.has(id);
      checkbox.checked = inSet;
      if (inSet) { checkbox.setAttribute('checked', ''); } else { checkbox.removeAttribute('checked'); }
      label.classList.toggle('is-checked', inSet);
    }
  });
}
window.reapplyCompareChecked = reapplyCompareChecked;

/* ─── Layout helpers ────────────────────────────────────────────────────── */

function bottomActiveTabs(tab_name) {
  var stored = localStorage.getItem('allProducts');
  var count  = stored ? JSON.parse(stored).length : 0;
  var wrap   = document.querySelector('.compare-bottom-wrap');
  if (!wrap) return;

  if (count > 0) {
    wrap.classList.remove('hidden');
    if (!wrap.classList.contains('hide-chat')) wrap.classList.add('hide-chat');
  } else {
    wrap.classList.remove('active', 'hide-chat');
    wrap.classList.add('hidden');
    var toggleEl = wrap.querySelector('[data-toggle-text]');
    if (toggleEl) { toggleEl.setAttribute('data-toggle-text', 'Show'); toggleEl.textContent = 'Show'; }
  }
  tabBottomPostion();
}

function tabBottomPostion() {
  var wrap = document.querySelector('.compare-bottom-wrap');
  if (!wrap) return;

  var bottom = 0;
  if (!wrap.classList.contains('hidden') && !wrap.classList.contains('hide')) {
    bottom = window.innerHeight - wrap.getBoundingClientRect().bottom;
    bottom = bottom < 0 ? 0 : bottom;
    bottom = bottom === window.innerHeight ? 0 : bottom;
  }

  var clientHeight = wrap.classList.contains('hidden') ? 0 : wrap.clientHeight;

  /* Mobile: offset above Jendco's fixed filter button */
  if ((document.body.classList.contains('collection-template') || document.body.classList.contains('search-template')) && window.innerWidth < 990) {
    var filterBar = document.querySelector('.mobile-facets__wrapper .disclosure-has-popup>summary');
    if (filterBar) {
      var fh = filterBar.clientHeight;
      bottom       = bottom + fh;
      clientHeight = Math.max(0, clientHeight - fh);
    }
  }

  document.documentElement.style.setProperty('--float-bottom', (clientHeight + bottom) + 'px');
  document.documentElement.style.setProperty('--compare-tray-h', clientHeight + 'px');
  document.body.classList.toggle('compare-tray-open', wrap.classList.contains('active'));
  setChatHeight();
}

function setEqualHeight() {
  var div1 = document.querySelector('.compare-float--content');
  var div2 = document.querySelector('.compare-float--suggestion.show');
  if (!div1) return;

  var eleSugge = document.querySelector('.compare-float.active .compare-float--suggestion.show');
  if (window.innerWidth > 989) {
    var container = document.querySelector('.compare-float .container');
    if (container && eleSugge) {
      var cw = container.clientWidth;
      var pl = Number((window.getComputedStyle(container).paddingLeft).replace('px', '')) * 2;
      var firstChild = div1.querySelector('.compare-float--item:not(.item-empty)');
      if (firstChild) eleSugge.style.width = (cw - pl - firstChild.clientWidth - 10) + 'px';
    }
  } else {
    if (eleSugge) eleSugge.style.width = '';
  }

  if (!div2) return;
  div1.style.minHeight = '';
  div2.style.minHeight = '';
  if (window.innerWidth < 990) return;

  var maxH = 0;
  div1.querySelectorAll('.compare-float--item').forEach(function(el) {
    maxH = Math.max(maxH, el.offsetHeight);
  });
  var finalMax = Math.max(maxH, div2.offsetHeight);
  div1.style.minHeight = finalMax + 'px';
  div2.style.minHeight = finalMax + 'px';
}

function setChatHeight() {
  var h = 0;
  var filtersBar = document.querySelector('.filters-short-bar-fixed');
  var compareWrap = document.querySelector('.compare-bottom-wrap');
  if (filtersBar) h += filtersBar.offsetHeight;
  if (compareWrap) h += compareWrap.offsetHeight;
  document.documentElement.style.setProperty('--live_chat_height', h + 'px');
}

/* ─── Init on DOMContentLoaded ──────────────────────────────────────────── */

if (document.body.classList.contains('compare-p')) {
  window.addEventListener('scroll', windowScrollCP);
  CheckCompareProducts();
  card_EqualHeight();
  syncScroll();
} else {
  function _initCompare() {
    CheckCompareProducts();
    setEqualHeight();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _initCompare);
  } else {
    _initCompare();
  }
  window.addEventListener('load', setEqualHeight);
  window.addEventListener('resize', setEqualHeight);
}
